export default {"viewBox":"0 0 20 20","body":"<path d=\"M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16z\"  fill-rule=\"evenodd\"/>"};